import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import campaignsService from "../../../services/campagins";

// Async thunk to fetch data issue summary
export const getDataIssueSummary = createAsyncThunk(
    "dataIssue/getSummary",
    async (body, thunkAPI) => {
        try {
            const response = await campaignsService.getDataIssueSummary(body);
            return response.data;
        } catch (error) {
            return thunkAPI.rejectWithValue(
                error?.response?.data?.message || error.message || "Unexpected error"
            );
        }
    }
);

// Async thunk to fetch campaign data issues
export const getCampaignDataIssues = createAsyncThunk(
    "dataIssue/fetchIssues",
    async (body, thunkAPI) => {
        try {
            const response = await campaignsService.getCampaignDataIssues(body);
            return response; // { data: [...], totalCount: number }
        } catch (error) {
            return thunkAPI.rejectWithValue(
                error?.response?.data?.message || error.message || "Failed to load campaign data issues"
            );
        }
    }
);

// Initial state
const initialState = {
    dataIssueSummary: {
        summary: null,
        loading: false,
        error: null,
    },
    dataIssueLogs: {
        dataIssues: [],
        totalCount: 0,
        dataIssueLoading: false,
        dataIssueError: null,
        snsStatSummary: null,
    },
};

// Slice
const dataIssueSlice = createSlice({
    name: "dataIssue",
    initialState,
    reducers: {
        resetDataIssueSummary: (state) => {
            state.dataIssueSummary = {
                summary: null,
                loading: false,
                error: null,
            };
        },
    },
    extraReducers: (builder) => {
        builder
            // Summary fetch
            .addCase(getDataIssueSummary.pending, (state) => {
                state.dataIssueSummary.loading = true;
                state.dataIssueSummary.error = null;
            })
            .addCase(getDataIssueSummary.fulfilled, (state, action) => {
                state.dataIssueSummary.loading = false;
                state.dataIssueSummary.summary = action.payload;
            })
            .addCase(getDataIssueSummary.rejected, (state, action) => {
                state.dataIssueSummary.loading = false;
                state.dataIssueSummary.error =
                    action.payload || "Failed to fetch data issue summary";
            })

            // Data issue logs fetch
            .addCase(getCampaignDataIssues.pending, (state) => {
                state.dataIssueLogs.dataIssueLoading = true;
                state.dataIssueLogs.dataIssueError = null;
            })
            .addCase(getCampaignDataIssues.fulfilled, (state, action) => {
                state.dataIssueLogs.dataIssueLoading = false;
                state.dataIssueLogs.dataIssues = action.payload?.data || [];
                state.dataIssueLogs.totalCount = action.payload?.total || 0;
            })
            .addCase(getCampaignDataIssues.rejected, (state, action) => {
                state.dataIssueLogs.dataIssueLoading = false;
                state.dataIssueLogs.dataIssueError = action.payload || "Failed to load campaign data issues";
            });
    },
});

// Export actions and reducer
export const { resetDataIssueSummary } = dataIssueSlice.actions;
export default dataIssueSlice.reducer;
